"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferToAddress = void 0;
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
/**
 * Function checks if token account is the mint of store account
 * or try to find out ATA of the token
 */
async function getTransferToAddress(connection, transferTokenTo, storeAccount) {
    let transferToAddress;
    let tokenAccount;
    const storeTokenAccount = await (0, solana_spl_token_modern_1.getAccount)(connection, storeAccount);
    try {
        // check if transfer token to is token account
        tokenAccount = await (0, solana_spl_token_modern_1.getAccount)(connection, transferTokenTo);
        transferToAddress = transferTokenTo;
    }
    catch (e) {
        // not possible to get, let's try to use ATA account
        const transferTokenToAta = (0, solana_spl_token_modern_1.getAssociatedTokenAddressSync)(storeTokenAccount.mint, transferTokenTo, true);
        // check if that ATA account exists
        tokenAccount = await (0, solana_spl_token_modern_1.getAccount)(connection, transferTokenToAta);
        transferToAddress = transferTokenToAta;
    }
    if (!tokenAccount.mint.equals(storeTokenAccount.mint)) {
        throw new Error('Of address ' +
            transferTokenTo.toBase58() +
            ' the token account ' +
            transferToAddress.toBase58() +
            ' is not a token account of ' +
            storeAccount.toBase58());
    }
    return transferToAddress;
}
exports.getTransferToAddress = getTransferToAddress;
//# sourceMappingURL=utils.js.map